import axios from 'axios';

export default {
  getRateTableList({ commit }, list) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/rate_table/list",
        params: {
          order_by: 'order_by',
          order_dir: 'order_dir',
          page: list.page || 0,
          rate_table_name: list.rate_name ? '*' + list.rate_name + '*' : '',
          per_page: list.perPage || 10,
        },
        method: "GET"
      }).then(res => {
        const { items: rateTables, total, per_page } = res.data.payload;
        commit('SET_ALL_RATE_TABLES', { rateTables, total, per_page });
        resolve(res.data.payload);
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  getRateTable({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/rate_table/" + id,
        method: "GET"
      }).then(res => {
        commit('SET_RATE_TABLE', res.data.payload);
        resolve(res.data.payload);
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  getRateTableNoCommit({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/rate_table/" + id,
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      })
        .catch(err => {
          reject(err);
        });
    });
  },
  addRateTable({ commit }, rate_table) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/rate_table",
        data: rate_table,
        method: "POST"
      })
      .then(res => {
        resolve(res.data.payload);
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  editRateTable({ commit }, list) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/rate_table/" + list.rate_table_uuid,
        data: list.data,
        method: "PATCH"
      })
      .then(res => {
        commit('EDIT_RATE_TABLE', res.data.payload);
        resolve(res.data.payload);
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  deleteRateTable({ commit }, id) {
    return axios({
        url: "/rate_table/" + id,
        method: "DELETE"
      }).then(res => {
        commit('REMOVE_RATE_TABLE', id);
        return res.data.payload;
      });
  },
  updateRate({ commit }, fields) {
    commit("UPDATE_RATE", fields);
  },
  updateRates({ commit }, rate) {
    commit("UPDATE_RATES", rate);
  },
  addRate({ commit }, rate) {
    commit('ADD_RATE', rate);
  },
  removeRate({commit}, index) {
    commit('REMOVE_RATE', index);
  },
  updateActiveRateId({ commit }, id) {
    commit('UPDATE_ACTIVE_RATE_ID', id);
  }
}
